import UltMeta, { Meta } from "@/meta/UltMeta/index";
import { THEME_COLOR } from "@/meta/common";

// 安装推广记录状态
class installPromotionReocrdState extends UltMeta {
    ACTIVATED = new Meta(1, "已激活");
    INVALID = new Meta(2, "已失效", THEME_COLOR.Info.intro);
}

export const INSTALL_PROMOTION_REOCRD_STATE = new installPromotionReocrdState();
